// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2gzfv","inner":"Form_inner__IZMH_","range":"Form_range__qjzjo","name":"Form_name__1HeUN","actions":"Form_actions__1buvY"};